import React from 'react';
import { useRef } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { useState } from 'react';
import { useEffect } from 'react';
import { Box } from '@mui/material';
import SessionPreview from '../../components/sessionPreview/SessionPreview';
import ActionSessionMenu from '../cardMedia/ActionSessionMenu';
import { Button } from '@mui/material';
import CardMedia from '../cardMedia';

export const SingleCarousel = ({ images = [], from, loading }) => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);
  const [hover, setHover] = React.useState(false);
  const [slidesToShow, setSlidesToShow] = React.useState(2.03);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  return (
    <div style={{ width: '100%' }} id={'lmsSlider'}>
      <Slider asNavFor={nav2} ref={slider1} dots={false} arrows={false} slidesToShow={slidesToShow}>
        {images.map((k, i) => {
          return (
            <Box
              component={'div'}
              display={'flex'}
              justifyContent="center"
              key={k.id}
              sx={{ maxWidth: '544px' }}
            >
              <CardMedia
                key={k}
                src={k?.imageUrl}
                alt={k?.title}
                id={k?.id}
                contentType={k.contentType}
                data={k.data}
                loading={loading}
                isClickable={true}
                type={'longTileImage'}
                style={{ width: '100%', height: '353px' }}
              />
            </Box>
          );
        })}
      </Slider>
    </div>
  );
};
